<template>
    <div>
        <!--websiteStatue 0:未创建项目 1:已经创建项目 2:编辑项目 3: 已经绑定域名未发布 4：已经发布项目  -->
        <ul class="site-main">
            <li v-for="(item,index) in projListData" :key="item.id+index">
                <div class="site-list-item" v-if="item.websiteStatue === '0'">
                    <div class="site-list-item-fl">
                        <div class="site-list-item-img">
                            <span>
                                <i class="iconfont" :class="item.projType === 'PC' ? 'icon-bianzu-15_2x' :'icon-shouji10'"></i>
                            </span>
                            <p>
                                已开通
                                <el-tooltip class="item" effect="light" popper-class="site-item-tooltip" content="网站已开通，请创建网站选择合适的方案制作" placement="top-start">
                                    <el-button>
                                        <i class="iconfont icon-bianzubeifen"></i>
                                    </el-button>
                                </el-tooltip>
                            </p>
                        </div>
                        <div class="site-item-txt">
                            <div class="site-item-title">建营销型网站，就上牛商云</div>
                            <ul>
                                <li>可视化操作</li>
                                <li>蜘蛛主动喂养</li>
                                <li>一键智能诊断</li>
                                <li>百套建站方案</li>
                            </ul>
                            <div>
                                <span v-html="dateFormat(item.ftpExpireTime,'YYYY.MM.DD')"></span>
                            </div>
                        </div>
                    </div>
                    <div class="site-item-btn" @click="openPageList('/pageList',item)">制作{{item.projType}}站</div>
                </div>
                <template v-else>
                    <div class="site-main-info">
                        <template v-if="item.experience === '0'">
                            <figure v-if="!item.projectIcon">
                                <img src="../../../assets/images/page-logo.png" />
                            </figure>
                            <figure v-if="item.projectIcon">
                                <img :src="formatImgUrl(item.projectIcon)" />
                            </figure>
                        </template>
                        <div class="site-item-img" v-else>
                            <span>
                                <i class="iconfont icon-bianzu-15beifen-2_2x"></i>
                            </span>
                            <p>
                                体验试用
                                <el-tooltip class="item" effect="light" popper-class="site-item-tooltip" content="每个用户有一个体验试用站点，欢迎体验最新功能和建站方案" placement="top-start">
                                    <el-button>
                                        <i class="iconfont icon-bianzubeifen"></i>
                                    </el-button>
                                </el-tooltip>
                            </p>
                        </div>
                        <div class="site-item-txt">
                            <b v-if="globals.baseUrl === 'https://lavrockt.nsw99.com'">{{item.projName}}</b>
                            <span>
                                <a :href="getProjUrl(item)" target="_blank" :title="getProjUrl(item)">{{getProjUrl(item)}}</a>
                            </span>
                            <i class="iconfont" :class="{'icon-bianzubeifen6':item.projType === 'PC','icon-bianzu5':item.projType === '手机','icon-xiangyingshi':item.projType === '响应式'}"></i>
                            <i class="iconfont icon-bianzu4" v-if="item.projType === '手机'" @click="scanQR(getProjUrl(item))" title="手机扫码浏览"></i>
                            <em class="site-item-version" v-if="item.webVersion>0" :class="`version${item.webVersion}`" :title="item.suitName"></em>
                            <em v-if="item.webStatus===1" class="site-item-state green">网站已上线</em>
                            <em v-if="item.webStatus===2" class="site-item-state blue">平台内发布</em>
                            <em v-if="item.webStatus===3" class="site-item-state orange">网站未发布</em>
                            <em v-if="item.webStatus===4" class="site-item-state red">域名未绑定</em>
                        </div>
                        <div class="site-time" v-if="item.webStatus===1 || item.newSuit">
                            <div v-html="dateFormat(item.ftpExpireTime,'YYYY.MM.DD')"></div>
                            <p v-if="maturity(item.ftpExpireTime,'YYYY.MM.DD')">
                                您的服务
                                <span>已到期</span>，为保证您的权益请
                                <em @click="openUrl('/renewal/index')">立即续费</em>
                            </p>
                            <p v-if="expiring(item.ftpExpireTime,'YYYY.MM.DD')">
                                您的服务
                                <span>即将到期</span>，为保证您的权益请
                                <em @click="openUrl('/renewal/index')">立即续费</em>
                            </p>
                        </div>
                        <div class="site-button">
                            <button class="site-btn" @click="editCurProjHtml(item, 'isfalse')">网站管理</button>
                            <button class="site-btn" @click="yxyun()">网站排名</button>
                            <button class="site-btn" @click="jumpViewSiteStas(item.id)">流量统计</button>
                            <button class="site-btn" @click="replaceSite(item)" v-if="isReplace(item.lineStartTime) && item.webType!=='落地页'">更换方案</button>
                            <button class="site-btn" @click="replaceWeb(item)" v-if="item.experience === '1' && isReplaceWebShowo(item) ">体验变正式</button>
                            <!-- <button class="site-btn" @click="openFtpDialog(item.ftpId)">FTP设置</button> -->

                            <div class="site-btn" @click="switchStu(item.id)" v-if="isToolSite && item.experience != 1 && item.webType!=='落地页'">
                                更多
                                <div class="more-operating" v-show="item.moreShow">
                                    <dl>
                                        <dd @click="editCurProjHtml(item, 'istrue')" :class="{'domain-null': !item.projectDomain}">设置域名</dd>
                                        <dd @click="findCheckHistory(item.id)">诊断记录</dd>
                                        <dd @click="getWebHostInfo(item.ftpId)" v-if="item.ftpId">空间信息</dd>
                                        <dd @click="searchEngine(item)">搜索引擎提交</dd>
                                        <dd @click="copyPageFn(item)">复制网站</dd>
                                        <!-- <dd @click="openUpdateStatus(item.id)" v-if="!item.ftpId">删除网站</dd> -->
                                    </dl>
                                </div>
                            </div>
                        </div>
                        <div class="site-statue" v-if="item.webStatus !=1">
                            <span :class="item.websiteStatue==='1' ? 'is-active':''">
                                <em>1</em>已开通
                                <i class="iconfont icon-jiantou"></i>
                            </span>
                            <span :class="item.websiteStatue==='2' ? 'is-active':''">
                                <em>2</em>装修网站
                                <i class="iconfont icon-jiantou"></i>
                            </span>
                            <span :class="item.websiteStatue==='3' ? 'is-active':''">
                                <em>3</em>绑定域名
                                <i class="iconfont icon-jiantou"></i>
                            </span>
                            <span :class="item.websiteStatue==='4' ? 'is-active':''">
                                <em>4</em>上线发布
                            </span>
                        </div>
                    </div>
                    <div class="site-main-count" v-if="item.webStatus ===1 ">
                        <dl>
                            <dt>浏览次数PV</dt>
                            <dd>{{item.pvCount}}</dd>
                        </dl>
                        <dl>
                            <dt>独立访客UV</dt>
                            <dd>{{item.uvCount}}</dd>
                        </dl>
                    </div>
                    <div class="sitm-status-txt" v-if="item.webStatus != 1  ">
                        <dl v-if="item.websiteStatue==='1'">
                            <dd>
                                <i>1</i>网站已开通，请尽快上传资料装修网站！
                            </dd>
                            <dd>
                                <i>2</i>公司没有专业人员制作，购买
                                <span>
                                    <a href="https://www.nswyun.com/floor/serve?goods_id=579" target="_blank">人工代装服务</a>
                                </span>
                            </dd>
                        </dl>
                        <dl v-if="item.websiteStatue==='2'">
                            <dd>
                                <i>1</i>担心网站上线没有营销力，一键
                                <span @click="editCurProjHtml(item, 'detect')">智能检测</span>
                            </dd>
                            <dd>
                                <i>2</i>担心误用网络图片造成侵权，购买
                                <span @click="openUrl('/gallery/pic')">正版图片</span>
                            </dd>
                        </dl>
                        <dl v-if="item.websiteStatue==='3'">
                            <dd>
                                <i>1</i>网站未绑定域名，请尽快
                                <span @click="editCurProjHtml(item, 'domain')">绑定域名</span>
                            </dd>
                            <dd>
                                <i>2</i>网站没有域名，
                                <span>
                                    <a href="https://www.nswyun.com/floor/domainRegister" target="_blank">立即购买</a>
                                </span>
                            </dd>
                        </dl>
                        <dl v-if="item.websiteStatue==='4'">
                            <dd>
                                <i>1</i>网站未上线发布，无法域名访问和优化推广，
                                <span @click="editCurProjHtml(item, 'online')">请尽快上线发布</span>
                            </dd>
                        </dl>
                    </div>
                </template>
            </li>
        </ul>
        <div ref="getListMore"></div>
        <p class="site-loading" v-if="loading">
            <img class="loading-gif" src="../../../assets/images/loading.gif" />站点信息正在加载中,请稍后...
        </p>
        <!-- <p class="site-loading" v-if="!loading && projListData.length === siteCount">
			{{siteCount === 0?'站点没有任何内容':''}}
        </p>-->

        <div class="QRmain" v-show="QRshow" @click="QRshow = false">
            <div>
                <canvas id="canvas" @click.stop></canvas>
                <p>手机扫码浏览</p>
            </div>
        </div>
        <DialogBuySite v-if="showBuySite"></DialogBuySite>
        <CheckHistory :show="show" :pid="projIdToHistory" @updateHistory="updateHistory"></CheckHistory>
        <WebReplace v-if="replaceShow" :replaceShow="replaceShow" :replaceData="replaceData" @updateReplaceWeb="updateReplaceWeb" @getList="getList"></WebReplace>

        <site-type-dialog v-if="showTypeDialog" :showDialog.sync="showTypeDialog" :tblType="tblType" @responseFn="responseFn" @closeCurModal="closeCurModal"></site-type-dialog>
        <yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint>
        <ftp-dialog ref="refFtpDialog" :ftpId="ftpId"></ftp-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { indexOf } from 'lodash'
import QRCode from 'qrcode'
import moment from 'moment'
import mixinsDialog from '@/mixins/mixinsDialog.js'
import ConsoleApi from '@/api/console.api'
import CheckHistory from '../site-component/CheckHistory'
import WebReplace from '../site-component/WebReplace'
import DialogBuySite from '@/pages/Template/component/DialogBuySite'
import SiteTypeDialog from './SiteTypeDialog'
import FtpDialog from './FtpDialog'

export default {
    name: 'SiteListMain',
    props: {
        siteType: {
            type: Number,
            default: 0
        }
    },
    inject: ['reload'],
    data () {
        return {
            projListData: [],
            loading: false,
            listLoading: false,
            pageSize: 10,
            pageNum: 1,
            size: 0,
            QRshow: false,
            tabAct: true,
            total: 0,
            ftpId: '',
            showFtp: false,
            show: false,
            projIdToHistory: '',
            projType: ['', 'PC', '手机'],
            isToolSite: false,
            showBuySite: false,
            replaceShow: false,
            webVersion: ['标准版', '旗舰版', '至尊版', '体验版', '经典版'],
            suitName: '0',
            replaceData: {
                pcCount: 0,
                mcCount: 0,
                projectId: '',
                projType: '',
            },
            showTypeDialog: false,
            tblType: '',
            queryInfo: {},
            pcCount: 0,
            mcCount: 0,
            pcNotSite: 0,//有空间没有建站的
            mcNotSite: 0,//有空间没有建站的

        }
    },
    mixins: [mixinsDialog],
    components: {
        CheckHistory, DialogBuySite, WebReplace, SiteTypeDialog, FtpDialog
    },
    created () {
        this.getSpace()
        this.getList()
        this.siteQuantity()
        this.isToolSite = this.$route.name === 'tool_site'
        // window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
        if (document.querySelector('.page-main')) {
            document.querySelector('.page-main').removeEventListener('scroll', this.handleScroll, true)
        }

    },
    watch: {
        siteType (newName, oldName) {
            this.projListData = []
            this.pageNum = 1
            console.log(this.projListData, 'projListData')
            this.getList()
        }
    },
    computed: {
        ...mapGetters('user', ['userInfo']),
        ...mapGetters('siteList', ['formatImgUrl']),
        ...mapGetters('templateConfig', ['filterCombo']),
        ...mapState('siteStas', ['siteCount']),
        ...mapState(['globals']),

    },
    methods: {
        ...mapActions('siteList', [
            'getProjList',
            'getProjHtml',
            'putCopy',
            'updProjectStatus'
        ]),
        ...mapActions('member', ['authorizeNewNSY']),
        ...mapMutations('template', ['setState']),
        ...mapMutations(['SET_SHOW_RECYCLE', 'SET_PROJECT_INFO']),
        ...mapMutations('siteList', ['setSiteListState']),
        ...mapMutations('siteStas', ['setSiteCount', 'delectSiteCount']),
        ...mapActions('siteStas', ['getSiteAccount', 'getSiteDaily']),
        ...mapMutations(['SET_PROJ_LIST_DATA']),
        // 站点更多展开显示
        switchStu (id) {
            this.projListData.forEach(item => {
                if (id === item.id) {
                    item.moreShow = !item.moreShow
                } else {
                    item.moreShow = false
                }
            })
        },
        expiring (data, str) {
            if (!data) return
            const Format = moment(data).format(str)
            const tiemInfo = moment(data).diff(moment().format(), 'days')
            return tiemInfo <= 90 && tiemInfo > 0
        },
        maturity (data, str) {
            if (!data) return
            const Format = moment(data).format(str)
            const tiemInfo = moment(data).diff(moment().format(), 'days')
            return tiemInfo <= 0
        },
        dateFormat (data, str) {
            if (!data) return ''
            const Format = moment(data).format(str)
            const tiemInfo = moment(data).diff(moment().format(), 'days')

            let txt = ''
            if (tiemInfo <= 0) {
                txt = ` 服务有效期：${Format} (<span>已到期</span>)`
            }

            if (tiemInfo <= 90 && tiemInfo > 0) {
                txt = ` 服务有效期：<em>${Format}(${tiemInfo}天)</em> `
            }
            return txt || `服务有效期：${Format} (${tiemInfo}天)`
        },
        //查看诊断记录
        findCheckHistory (id) {
            this.projIdToHistory = id
            this.show = true
        },
        updateHistory () {
            this.show = false
        },
        getProjUrl (curProj) {
            return curProj.projectDomain ? 'http://' + curProj.projectDomain : this.globals.baseUrl + '/page/projhtml?&projId=' + curProj.id
        },
        // 分页获取站点列表
        async getList () {
            this.loading = true
            let params = {
                userId: this.userInfo.uid,
                status: 0,
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                projType: this.projType[this.siteType]
            }
            const { data } = await ConsoleApi.getSitesList(params)
            if (data.isSuccess) {
                let list = data.data.list.map(value => {
                    value.moreShow = false
                    value.pvCount = '0'
                    value.uvCount = '0'
                    return value
                })
                this.projListData = this.pageNum === 1 ? list : this.projListData.concat(list)
                this.projListData.forEach((item) => {
                    if (item.ftpId) {
                        if (item.lineStartTime) {
                            item['webStatus'] = 1 //站外上线
                        } else if (item.serviceStartTime && !item.lineStartTime) {
                            item['webStatus'] = 2//站内上线
                        } else if (!item.serviceStartTime && !item.lineStartTime && item.projectDomain) {
                            item['webStatus'] = 3 //未发布
                        } else if (!item.projectDomain) {
                            item['webStatus'] = 4 //未绑定域名
                        }
                    } else {
                        item['webStatus'] = 0
                    }
                    item.webVersion = indexOf(this.webVersion, item.suitName) + 1
                })
                this.total = data.data.total
                this.SET_PROJ_LIST_DATA(this.projListData)
                this.setSiteCount(data.data.total)
                this.getPvUvData(list)
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                })
            }
            this.loading = false
        },
        // 编辑当前站点
        editCurProjHtml (item, isConfig) {
            //判断是否学习完
            this.$toast('true')
            if (sessionStorage.getItem('isLearn') === 'false') {
                return
            }
            let type = item.projType == 'PC' ? 'pctype' : 'mctype'

            if (item.projType === '响应式') {
                type = this.siteType === 2 ? 'mctype' : 'pctype'
            }
            let query = {
                projId: item.id,
                edit: 'true',
                type: type,
                experience: item.experience || 1, //判断是否为体验站点， 1是 0 否
                prodType: item.prodType,
                // config: isConfig,
                curTab: isConfig != 'isfalse' ? isConfig : undefined
            }
            if (item.webType === '落地页') {
                query.pageId = item.pageId
                // query.isLdy = 1
            }

            let originRouter = this.$router.resolve({
                name: 'template',
                query
            })
            if (isConfig != 'isfalse') {
                window.localStorage.setItem('isConfig', 'isConfig')
            }
            window.open(originRouter.href)
        },
        // PV UV
        getPvUvData (projList) {
            let endDay = moment().format('YYYY-MM-DD')
            projList.forEach(curProjData => {
                this.getSiteAccount(curProjData.id).then(curAccountData => {
                    let params = {
                        account: curAccountData.account,
                        siteId: curAccountData.site,
                        startDay: curProjData.createdTime.split(' ')[0],
                        endDay: endDay
                    }
                    this.getSiteDaily(params).then(data => {
                        curProjData.pvCount = data.pvCount || 0
                        curProjData.uvCount = data.uvCount || 0
                    }, err => {
                        console.log(err)
                    })
                }).catch(err => {
                    console.log(err)
                })
            })
        },
        // 查看流量统计
        jumpViewSiteStas (id) {
            const routeData = this.$router.resolve({ name: 'flowInfo', query: { projId: id } })
            window.open(routeData.href, '_blank')
            // this.$router.push({
            // 	name: 'flowInfo',
            // 	query: {
            // 		projId: id
            // 	}
            // })
        },
        //判断是否允许更换方案
        isReplace (tiem) {
            if (!tiem) return true
            const Format = moment(tiem).format()
            const currentTiem = moment().format()
            const tiemInfo = moment(currentTiem).diff(Format, 'days')
            return tiemInfo <= 90
        },
        //是否显示变更按钮
        isReplaceWebShowo (item) {
            let count = item.projType === 'PC' ? this.replaceData.pcCount : this.replaceData.mcCount
            const replaceData = this.projListData.filter(data => {
                return data.projType === item.projType && data.experience != '1' && this.isReplace(data.lineStartTime)
            })
            //列表有小于90或者 还有待开通站点
            return replaceData.length > 0 || count > 0
        },
        //更换方案
        replaceSite (item) {
            const params = {
                experience: item.experience,
                replaceId: item.id,
                tblType: item.projType
            }
            this.openUrl('/pageList', params)
        },

        //更换站点
        replaceWeb (item) {
            this.replaceData.projectId = item.id
            this.replaceShow = true
            this.replaceData.projType = item.projType
        },
        updateReplaceWeb () {
            this.replaceShow = false
        },

        async getSpace () {
            const params = {
                userId: this.userInfo.uid
            }
            const { data } = await ConsoleApi.getSpace(params)
            if (data.isSuccess) {
                this.replaceData.pcCount = data.data.PC
                this.replaceData.mcCount = data.data.mobile
            } else {
                console.log(data.message)
            }
        },
        // 滚动加载
        handleScroll () {
            // let height = document.body.offsetHeight + window.pageYOffset
            let sTop = document.querySelector('.page-main').scrollTop
            let cHeigth = document.querySelector('.page-main').clientHeight
            let listTop = this.$refs.getListMore || 0
            if (listTop === 0) {
                return
            }
            let height = cHeigth + sTop - (this.isToolSite ? 20 : 200)

            if (height >= listTop.offsetTop && this.projListData.length < this.total) {
                if (this.loading || this.showDialog || !this.tabAct) return
                this.pageNum++
                this.getList()
            }
        },
        //手机网站二维码
        scanQR (url) {
            this.QRshow = true
            let canvas = document.getElementById('canvas')
            QRCode.toCanvas(canvas, url, function (error) {
                if (error) console.error(error)
            })
        },
        async yxyun () {
            const parmas = {
                route: 'castrow',
                type: '4',
            }
            let data = await this.authorizeNewNSY(parmas)
            if (data.isSuccess) {
                window.open(data.nswUrl)
            } else {
                this.$message.error('授权登陆失败')
            }
        },
        searchEngine (data) {
            let projectInfo = {
                id: data.id,
                projName: data.projName
            }
            this.SET_PROJECT_INFO(projectInfo)
            this.SET_SHOW_RECYCLE(2)
        },
        //查看空间信息
        getWebHostInfo (ftpId) {

            this.$parent.whichToShow({
                key: 'space',
                ftpId
            })
        },
        //复制当前网站
        copyPageFn (item) {
            this.openErrDialog('ask', '操作信息提示', 'putCopyPages', { item }, `确定复制当前网站吗？复制将开通新的${item.projType}站`, '确定', '', '', '')
        },
        async putCopyPages (backParams) {
            const isCount = await this.siteQuantity(backParams.item.projType)
            if (isCount) return
            this.$emit('load', true)
            this.putCopy(backParams.item.id).then(res => {
                if (res.isSuccess) {
                    // 复制后刷新版块
                    this.$emit('load', false)
                    this.reload()
                    this.$message({
                        message: res.data,
                        type: 'success'
                    })
                } else {
                    this.openErrDialog('ask', '操作信息提示', '', '', res.message, '确定', '', '', '')
                }

            })
        },
        async siteQuantity (projType) {
            const params = {
                userId: this.userInfo.uid
            }
            const { data } = await ConsoleApi.getSpace(params)
            if (data.isSuccess) {
                this.pcCount = data.data.PC
                this.mcCount = data.data.mobile
                if ((projType === 'PC' && data.data.PC === 0) || (projType === '手机' && data.data.mobile === 0)) {
                    this.showBuySite = true
                    this.setState({ showBuySite: true })
                    return true
                }
                return false
            } else {
                console.log(data.message)
                return true
            }
        },
        openUrl (url, params) {
            const routeData = this.$router.resolve({ path: url, query: params })
            window.open(routeData.href, '_blank')
        },
        async openPageList (url, item) {
            const { projType, id, experience, suitName } = item
            let linkData = {
                tblType: projType,
                replaceId: id,
                isNewSuit: true,
                experience
            }
            if (item.webType === '落地页') {
                window.open(`#/leaflet/手机/${id}/1`, '_blank')
                return
            }
            this.openUrl(url, linkData)
        },
        // 弹框提示选择响应式建站
        responseFn () {
            let params = JSON.parse(JSON.stringify(this.queryInfo))
            params.tblType = '响应式'
            params.suitName = this.suitName
            this.openUrl('/pageList', params)
        },
        // 弹框提示选择独立分开建站
        closeCurModal (data) {
            this.openUrl('/pageList', this.queryInfo)
        },
        // 打开FTP编辑弹框
        openFtpDialog (ftpId) {
            this.$refs.refFtpDialog.showFn(ftpId)
        }
    },
    mounted () {
        if (document.querySelector('.page-main')) {
            document.querySelector('.page-main').addEventListener('scroll', this.handleScroll, true)
        }


    }
}

</script>

<style scoped lang="scss">
.site-main {
    min-height: 50px;
    & > li {
        padding: 50px 0;
        min-height: 50px;
        border-bottom: 1px solid #c6cde6;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        .site-main-info {
            max-width: 766px;
            position: relative;
            padding-left: 120px;
            // width: 620px;
            min-height: 98px;

            figure {
                position: absolute;
                left: 0;
                top: 0;
                width: 90px;
                height: 90px;
                line-height: 90px;
                border-radius: 2px;
                padding: 4px;
                border: 1px dashed #888888;
                line-height: 0;
                overflow: hidden;
                text-align: center;

                img {
                    display: inline-block;
                    vertical-align: middle;
                    max-width: 100%;
                    max-height: 100%;
                }
            }
        }
        .site-statue {
            padding-top: 20px;
            font-size: 12px;
            line-height: 16px;
            color: #8392a4;
            em {
                display: inline-block;
                width: 16px;
                height: 16px;
                margin-right: 4px;
                border: 1px solid #8392a4;
                font-size: 12px;
                line-height: 12px;
                text-align: center;
                border-radius: 50%;
            }
            i {
                vertical-align: middle;
                margin: 0 24px;
                font-size: 16px;
            }
            .is-active,
            .is-active i {
                color: $colorA;
                em {
                    border-color: $colorA;
                    background-color: $colorA;
                    color: #fff;
                }
            }
        }
        .site-main-count {
            width: 208px;
            text-align: center;
            display: flex;
            justify-content: space-between;
            margin-right: 8.5%;

            dt {
                font-size: 12px;
                color: #373d45;
                line-height: 18px;
                margin-bottom: 20px;
            }

            dd {
                font-size: 26px;
                font-weight: bold;
                color: #4258ab;
                line-height: 38px;
                overflow: hidden;
                margin-bottom: 17px;
            }
        }
    }

    li:first-child {
        margin-top: 0;
    }
    .site-btn {
        display: inline-block;
        width: 88px;
        height: 34px;
        margin-top: 0;
        margin-right: 20px;
        padding: 0;
        position: relative;
        text-align: center;
        border-radius: 2px;
        background: none;
        border: 2px solid rgba(67, 88, 171, 0.2);
        font-size: 12px;
        line-height: 30px;
        color: #4358ab;
        cursor: pointer;

        &:hover {
            background-color: $colorA;
            color: #fff;
        }
    }
    div.site-btn {
        margin-right: 0;
    }
    .site-button {
        line-height: 0;
        min-height: 34px;
    }
}

.mr24 {
    margin-right: 24px;
}
.btn {
    position: relative;
    display: inline-block;
    margin-top: 14px;
    line-height: 37px;
    height: 37px;
    padding: 0 26px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    color: #515567;
    font-size: 14px;

    &:hover {
        color: #fff;
        background: $colorA;
        border: 1px solid $colorA;
    }
}

.more-operating {
    position: absolute;
    bottom: 36px;
    left: 50%;
    width: 94px;
    padding-bottom: 14px;
    margin-left: -47px;

    dl {
        position: relative;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        background: #fff;

        &:before {
            content: "";
            position: absolute;
            left: 50%;
            bottom: -6px;
            width: 10px;
            height: 10px;
            border-right: 1px solid #dcdfe6;
            margin-left: -5px;
            border-bottom: 1px solid #dcdfe6;
            background: #fff;
            transform: rotate(45deg);
            -webkit-transform: rotate(45deg);
        }

        dd {
            line-height: 28px;
            text-align: center;
            overflow: hidden;
            color: #383a4c;

            &:hover {
                color: $colorA;
            }
            &.domain-null {
                color: $colorA;
            }
        }
    }
}

.site-loading {
    margin: 50px 0;
    text-align: center;
    color: #858585;
}

.icon-erweima {
    cursor: pointer;
}

.icon-pc,
.icon-shouji,
.icon-xiangyingshi {
    color: $colorA;
}

.QRmain {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    text-align: center;

    &:before {
        content: "";
        display: inline-block;
        height: 100%;
        width: 0;
        vertical-align: middle;
    }

    div {
        display: inline-block;
        vertical-align: middle;

        canvas {
            display: block;
            width: 300px !important;
            height: 300px !important;
        }

        p {
            width: 300px;
            padding-bottom: 15px;
            background: #fff;
            color: #000;
            font-size: 16px;
        }
    }
}
.sitm-status-txt {
    margin-right: 2%;
    width: 340px;
    height: 94px;
    background: #fdeee9;
    position: relative;
    padding: 11px 0 0 20px;
    &::after {
        content: "";
        position: absolute;
        top: -8px;
        left: -8px;
        width: 356px;
        height: 110px;
        border-radius: 8px;
        border: 1px dashed rgba(241, 89, 42, 1);
    }
    dl {
        position: relative;
        z-index: 99;
    }
    font-size: 12px;
    line-height: 36px;
    i {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-right: 8px;
        border: 1px solid rgba(241, 89, 42, 1);
        line-height: 14px;
        text-align: center;
        color: rgba(241, 89, 42, 1);
        border-radius: 50%;
    }
    span,
    a {
        cursor: pointer;
        color: $colorD;
        text-decoration: underline;
    }
}
.site-item-img {
    position: absolute;
    left: 0;
    top: 0;
    width: 90px;
    height: 90px;
    margin-right: 30px;
    padding-top: 6px;
    background: rgba(231, 236, 248, 1);
    border-radius: 4px;
    text-align: center;
    & > span i {
        font-size: 36px;
        color: #373d45;
    }
    p {
        font-size: 12px;
        line-height: 17px;
        color: #373d45;
        .el-button {
            width: 12px;
            height: 12px;
            padding: 0;
            margin-left: 4px;
            border: 0;
            background: none;
            &:hover {
                color: #373d45;
            }
        }
        i {
            font-size: 12px;
        }
    }
}
.site-list-item {
    display: flex;
    align-items: center;
    .site-list-item-fl {
        width: 554px;
        height: 90px;
        display: flex;
    }
    .site-list-item-img {
        width: 90px;
        height: 90px;
        margin-right: 30px;
        padding-top: 6px;
        background: rgba(231, 236, 248, 1);
        border-radius: 4px;
        text-align: center;
        & > span i {
            font-size: 36px;
            color: #373d45;
        }
        p {
            font-size: 12px;
            line-height: 17px;
            color: #373d45;
            .el-button {
                width: 12px;
                height: 12px;
                padding: 0;
                border: 0;
                background: none;
                &:hover {
                    color: #373d45;
                }
            }
            i {
                font-size: 12px;
            }
        }
    }
    .site-item-txt {
        font-size: 12px;
        line-height: 27px;
        color: #373d45;
    }
    .site-item-title {
        margin-bottom: 15px;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        color: #373d45;
    }
    ul {
        width: 190px;
        display: flex;
        flex-wrap: wrap;
    }
    li {
        width: 50%;
        padding-left: 14px;
        position: relative;
        &:after {
            content: "";
            width: 4px;
            height: 4px;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -2px;
            background: #373d45;
        }
    }

    .site-item-btn {
        width: 90px;
        height: 30px;
        background: #f1592a;
        border-radius: 2px;
        font-size: 12px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        cursor: pointer;
    }
}

.site-item-txt {
    margin-bottom: 13px;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: #272828;
    span {
        max-width: 266px;
        line-height: 24px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
        cursor: default;
        a {
            color: $colorA;
        }
    }
    i {
        margin-left: 6px;
        vertical-align: middle;
    }
    .site-item-state {
        display: inline-block;
        vertical-align: middle;
        height: 24px;
        margin-left: 14px;
        background-color: #ff9000;
        border-radius: 2px;
        line-height: 24px;
        padding: 0 10px;
        color: #fff;
    }
    .green {
        background-color: #e6f8ef;
        color: #5ecd96;
    }
    .blue {
        background-color: #ebedfc;
        color: #626be7;
    }
    .orange {
        background-color: #fff8ef;
        color: #ffb141;
    }
    .red {
        background-color: #ffefef;
        color: #ff6d6d;
    }
    .site-item-version {
        margin-left: 20px;
        display: inline-block;
        vertical-align: middle;
        width: 69px;
        height: 24px;
        background: url(../../../assets/images/imgSprites.png);

        &.version5 {
            background-position: 0 0;
        }
        &.version4 {
            background-position: 0 -24px;
        }
        &.version1 {
            background-position: 0 -48px;
        }
        &.version2 {
            background-position: 0 -72px;
        }
        &.version3 {
            width: 95px;
            background-position: 0 -96px;
        }
    }
}

.site-time {
    margin-bottom: 20px;
    line-height: 17px;
    color: #373d45;
    position: relative;
    em {
        color: #ff2f00;
    }
}
</style>
